import { ref, watch } from 'vue'

// 編輯器透過 v-model 回傳完整 JSON 設定，不直接修改上層傳入的物件。
export function useCommerceContentModel(props, emit) {
  const copy = value => JSON.parse(JSON.stringify(value))
  const form = ref(copy(props.modelValue))
  watch(() => props.modelValue, value => {
    if (JSON.stringify(value) !== JSON.stringify(form.value)) form.value = copy(value)
  })
  watch(form, value => {
    if (JSON.stringify(value) !== JSON.stringify(props.modelValue)) emit('update:modelValue', copy(value))
  }, { deep: true })
  return form
}
